// Preferência de tema por aparelho (claro, escuro ou seguir o sistema). Só conveniência local:
// sem storage (aba anônima, bloqueio), cai no padrão do sistema.

export type PreferenciaTema = 'sistema' | 'claro' | 'escuro';

const CHAVE = 'preferencia-tema';

export function lerPreferenciaTema(): PreferenciaTema {
  try {
    const valor = localStorage.getItem(CHAVE);
    return valor === 'claro' || valor === 'escuro' ? valor : 'sistema';
  } catch {
    return 'sistema';
  }
}

/** Aplica no <html> (as variáveis do tema respondem a data-tema) e guarda a escolha. */
export function aplicarPreferenciaTema(preferencia: PreferenciaTema, guardar = true): void {
  const raiz = document.documentElement;
  if (preferencia === 'sistema') delete raiz.dataset.tema;
  else raiz.dataset.tema = preferencia;
  if (!guardar) return;
  try {
    if (preferencia === 'sistema') localStorage.removeItem(CHAVE);
    else localStorage.setItem(CHAVE, preferencia);
  } catch {
    // sem storage: vale só até recarregar
  }
}
